<template>
  <v-card flat elevation="5">
    <v-lazy
        v-model="lazyActive"
        min-height="400"
        :options="{
        threshold: 0.1,
      }"
        transition="fade-transition"
    >
      <Charts :option="singleCustomerChart"/>
    </v-lazy>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  props: {
    chartInfoState: Boolean,
  },
  components: {
    Charts: () => import("@/components/Charts.vue"),
  },
  methods: {
    ...mapActions("customanalysis", ["updateInterestReport"]),
    scrollTo() {
      this.$emit("goto", "#Distributed");
    },
  },
  computed: {
    ...mapGetters("customanalysis", ["getDate", "getCustomerReport"]),
    singleCustomerChart() {
      const option = this.reportData;
      const report = this.getCustomerReport;
      if (report.seriesData) {
        option.title.text = report.chartTitle;
        option.series[0].data = [...report.seriesData];
        option.plotOptions.series.events = {
          click: () => {
            this.scrollTo();
            this.updateInterestReport(event.point.index);
          },
        };
      }
      this.chartOption = option;
      return option;
    },
  },
  watch: {
    chartInfoState() {
      if (this.chartInfoState === true) {
        let chartInfo = {
          data: this.chartOption,
          id: "CustomerGroupAnalysis"
        };
        chartInfo.data.plotOptions.series.events = this.updateInterestReport(0);
        this.$emit("addChartInfo", chartInfo);
      }

    }
  },
  data: () => ({
    lazyActive: false,
    reportData: {
      title: {
        text: "客群分析圖",
        style: {
          fontFamily: "Roboto,sans-serif",
        },
      },
      subtitle: {
        text: "",
      },
      tooltip: {
        valueSuffix: "%",
      },
      plotOptions: {
        series: {
          cursor: "pointer",
          animation: {
            duration: 400,
            easing: "easeOutBounce",
          },
        },
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      legend: {
        align: "center",
        verticalAlign: "top",
      },
      series: [
        {
          type: "treemap",
          layoutAlgorithm: "stripes",
          alternateStartingDirection: true,
          levels: [
            {
              level: 1,
              layoutAlgorithm: "sliceAndDice",
              dataLabels: {
                enabled: true,
                align: "left",
                verticalAlign: "bottom",
                style: {
                  fontSize: "15px",
                  fontWeight: "bold",
                },
              },
            },
          ],
          legendType: "point",
          showInLegend: true,
          data: [],
        },
      ],
      credits: {
        enabled: false,
      },
      exporting: {
        relativeTo: "chart",
        buttons: {
          contextButton: {
            //改button樣式
            symbol: "download",
            menuItems: ["downloadCSV"],
          },
        },
      },
      helpIcon: {
        annotation: "目前網站客群的分布狀態",
        enabled: true,
      }
    },
  }),
};
</script>
